import { DataTable } from "@/components/admin/data-table";
import { List } from "@/components/admin/list";
import { NumberField } from "@/components/admin/number-field";
import { SearchInput } from "@/components/admin/search-input";
import { SelectInput } from "@/components/admin/select-input";

import { useProductFilterChoices } from "./useProductFilterChoices";

export const ProductList = () => {
  const { choices } = useProductFilterChoices();
  const filters = [
    <SearchInput
      key="q"
      source="producto@ilike"
      alwaysOn
      placeholder="Buscar producto..."
    />,
    <SelectInput key="clase" source="clase" label="Clase" choices={choices.clase} />,
    <SelectInput key="marca" source="marca" label="Marca" choices={choices.marca} />,
    <SelectInput key="origen" source="origen" label="Origen" choices={choices.origen} />,
    <SelectInput key="color" source="color" label="Color" choices={choices.color} />,
  ];

  return (
    <List
      title="Productos"
      perPage={25}
      sort={{ field: "producto", order: "ASC" }}
      filters={filters}
    >
      <DataTable>
        <DataTable.Col source="clase" label="Clase" />
        <DataTable.Col source="codigo" label="Código" />
        <DataTable.Col source="marca" label="Marca" />
        <DataTable.Col source="origen" label="Origen" />
        <DataTable.Col source="producto" label="Producto" />
        <DataTable.Col source="color" label="Color" />
        <DataTable.Col source="textura" label="Textura" />
        <DataTable.Col source="formato" label="Formato" />
        <DataTable.Col source="precio" label="Precio" field={NumberField} />
        <DataTable.Col source="precio_iva" label="Precio + IVA" field={NumberField} />
      </DataTable>
    </List>
  );
};
